import Link from "next/link";
import Image from "next/image";
import ser_icon_1 from "@/assets/img/icon/home/WHY-study-at-HTU.svg";
import ser_icon_2 from "@/assets/img/icon/home/HOW-to-study-at-HTU.svg";
import ser_icon_3 from "@/assets/img/icon/home/WHAT-to-study-at-HTU.svg";
import ser_icon_4 from "@/assets/img/icon/home/Scholarships.svg";
import { getLocalizedPath, ifArabic } from "@/utils/language";
import { ArrowIcons } from "../svg";
import { useLanguage } from "@/app/[lang]/client/language-context";

// service data
const service_data = [
  {
    id: 1,
    icon: ser_icon_1,
    title: "WHY study at HTU?",
    titleAr: "لماذا تدرس في HTU؟",
    text: "Empowering future innovators with cutting-edge skills, hands-on learning, and career-ready opportunities.",
    textAr:
      " نمنحك المهارات الحديثة والتدريب العملي والفرص المهنية التي تصنع مستقبل المبتكرين.",
    href: "/about-htu",
  },
  {
    id: 2,
    icon: ser_icon_2,
    title: "HOW to study at HTU?",
    titleAr: "كيف تلتحق بـ HTU؟",
    text: "Your journey to success starts here—discover our seamless admission process and unique learning pathways.",
    textAr:
      "ابدأ رحلتك نحو المستقبل من هنا؛ تعرّف على خطوات الالتحاق ومسارات التعلّم الفريدة.",
    href: "/admission/how-to-apply",
  },
  {
    id: 3,
    icon: ser_icon_3,
    title: "WHAT to study at HTU?",
    titleAr: "ماذا تدرس في HTU؟",
    text: "Explore cutting-edge programs designed to fuel your passion and prepare you for tomorrow's industries.",
    textAr:
      " اكتشف برامج دراسية متقدمة مصممة لتغذية شغفك وتأهيلك لسوق العمل المستقبلي.",
    href: "/admission/programs",
  },
  {
    id: 4,
    icon: ser_icon_4,
    title: "Scholarships",
    titleAr: "المنح الدراسية",
    text: "Discover a range of scholarships designed to support your educational journey and future success.",
    textAr:
      " تعرّف على مجموعة من المنح المصمّمة لدعم رحلتك التعليمية وتحقيق طموحاتك المهنية.",
    href: "/admission/scholarships",
  },
];

const ServiceOne = () => {
  const { language } = useLanguage();
  return (
    <section className="service-area tp-service-bg grey-bg">
      <div className="container">
        <div className="row">
          {service_data.map((item, index) => (
            <div key={item.id} className="col-lg-3 col-md-6">
              <div
                className={`tp-service-item text-center mb-40 wow fadeInUp ${
                  index === service_data.length - 1 ? "lastItem" : ""
                }`}
                data-wow-delay={`.${item.id}s`}
              >
                <div className="tp-service-wrap">
                  <div className="tp-service-icon">
                    <span>
                      <Image
                        src={item.icon}
                        alt="service-icon"
                        width={64}
                        height={64}
                        loading="lazy"
                        decoding="async"
                      />
                    </span>
                  </div>
                  <h2 className="tp-service-title">
                    <Link
                      href={getLocalizedPath(item.href ?? "#", language)}
                      aria-label={item.title || "Service Link"}
                      dangerouslySetInnerHTML={{
                        __html: ifArabic(item.titleAr, item.title),
                      }}
                    ></Link>
                  </h2>
                  <div className="tp-service-btn">
                    <Link
                      aria-label={item.title}
                      href={getLocalizedPath(item.href || "#", language)}
                    >
                      <span>
                        {ifArabic(
                          <ArrowIcons.LeftArrowTwo />,
                          <ArrowIcons.RightArrowTwo />
                        )}
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="tp-service-content">
                  <p>{ifArabic(item.textAr, item.text)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOne;
